import { useState } from "react";
import { Search, X } from "lucide-react";
import { searchLessons } from "@/lib/api";
import { toast } from "sonner";

export default function ScriptureSearch({ onResults, onClear }) {
    const [q, setQ] = useState("");
    const [busy, setBusy] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        const query = q.trim();
        if (!query) return;
        setBusy(true);
        try {
            const res = await searchLessons(query);
            onResults?.(res);
            if (res.results.length === 0) {
                toast.message(`No lessons match "${query}"`, {
                    description: "Try a Bible book (e.g. 'Mark'), a reference, or a theme.",
                });
            }
        } catch (err) {
            toast.error("Search failed.");
        } finally {
            setBusy(false);
        }
    }

    function handleClear() {
        setQ("");
        onClear?.();
    }

    return (
        <form onSubmit={handleSubmit} className="flex items-center gap-2 w-full sm:w-auto" data-testid="scripture-search">
            <div className="relative flex-1 sm:flex-initial">
                <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-ink/50" strokeWidth={2.5} />
                <input
                    type="text"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    placeholder="Search by book, verse, theme..."
                    className="w-full sm:w-72 border-2 border-ink rounded-full bg-white pl-10 pr-9 py-2 text-sm font-semibold focus:outline-none focus:ring-4 focus:ring-sky"
                    data-testid="scripture-search-input"
                />
                {q && (
                    <button type="button" onClick={handleClear} className="absolute right-3 top-1/2 -translate-y-1/2 text-ink/60 hover:text-ink" aria-label="Clear">
                        <X className="w-4 h-4" strokeWidth={2.5} />
                    </button>
                )}
            </div>
            <button type="submit" disabled={busy} className="btn-sticker bg-sky text-white text-sm disabled:opacity-60" data-testid="scripture-search-submit">
                {busy ? "..." : "Search"}
            </button>
        </form>
    );
}
